import { PMCountCategoriesCard } from "@pimo/pimo-components/src/lib/pm-components";

import { APP_ROUTES } from "../../../constants";
import { getDropdownCount } from "../../../utils/dropdown-options";
import { isFieldEnabled } from "../../field-enabled";
import { DashboardCardContext } from "../context";

export function addCountCompletionOfProjectsCard(ctx: DashboardCardContext) {
  const { view, app, language, getCardCopy } = ctx;

  const countCompletionOfProjectsComponent = view.addComponent({
    component: PMCountCategoriesCard,
    layoutProps: {
      componentId: "countCompletionOfProjectsComponent",
      labels: ["completion", "count"],
      description: getCardCopy(language, "projectCompletionCounts").description,
      title: getCardCopy(language, "projectCompletionCounts").title,
    },
  });

  countCompletionOfProjectsComponent.mapLayoutProps(() => {
    return {
      componentId: "countCompletionOfProjectsComponent",
      labels: ["completion", "count"],
      title: getCardCopy(language, "projectCompletionCounts").title,
      description: getCardCopy(language, "projectCompletionCounts").description,
    };
  });

  countCompletionOfProjectsComponent.mapState((appState) => {
    const projectDegreeOfCompletionCounts =
      appState.dashboard?._calculated?.projectDegreeOfCompletionCounts ?? {};
    const data =
      appState.settings?.configuration?.degreeOfCompletionDefinition?.map(
        (entry) => {
          return {
            label: entry.name ?? "",
            count: getDropdownCount(projectDegreeOfCompletionCounts, entry),
            color: entry.color ?? "",
          };
        }
      ) ?? [];

    const handleCompletionFilter = (completion?: string) => {
      app.patchAppState({
        filterData: {
          searchQueryFilter: [],
          statusFilter: [],
          completionFilter: completion ? [completion] : [],
          categoryFilter: [],
          updateStatusFilter: [],
        },
      });
      app.navigate(APP_ROUTES.overview);
    };

    return {
      title: getCardCopy(language, "projectCompletionCounts").title,
      icon: "DonutLarge",
      data,
      onCardClick: () => handleCompletionFilter(),
      onSegmentClick: (segmentIndex: number) =>
        handleCompletionFilter(data[segmentIndex]?.label),
    };
  });

  countCompletionOfProjectsComponent.mapVisibility(({ settings }) =>
    isFieldEnabled(settings, "completion", "itemReporting")
  );
}
